import { useState } from "react";
import { measureTextScale } from "../utils/textScale";

/**
 * Android's font size as the page sees it (1 at the default), for sizing what the setting does not reach on its own:
 * the WebView enlarges font sizes and line heights, but not widths in px, em or rem. Read once per mount: changing
 * Android's font size restarts the app's screen, so a mounted component never sees it change.
 */
export const useTextScale = (): number => {
	const [textScale] = useState<number>(measureTextScale);
	return textScale;
};
